import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'LocalVersionBanner',
  props: {
    content: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})